import { useQuery } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import { getGoalIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useGoalDetailQuery = (
	id: number | null,
	options?: { enabled?: boolean },
) => {
	return useQuery({
		queryKey: GoalsKeys.detail(id),
		queryFn: processResponseQuery(() => getGoalIdV2(id!), {
			nullOn404: true,
		}),
		enabled: id !== null && options?.enabled !== false,
	});
};
